import { Box, Card, Text } from '@ksyos/design-system';
import { EmptyFolderIcon } from '@frontend/components/elements/EmptyFolderIcon';

interface IEmptyListPlaceholderProps {
    doNotWrapInCard?: boolean;
    subtitle: string;
}

export function EmptyListPlaceholder(props: IEmptyListPlaceholderProps) {
    const component = (
        <Box
            alignItems="center"
            display="flex"
            flexDirection="column"
        >
            <EmptyFolderIcon style={{ marginBottom: '16px' }} />
            <Text size="sm">{props.subtitle}</Text>
        </Box>
    );

    return props.doNotWrapInCard ? (
        component
    ) : (
        <Card>
            <Card.Body>{component}</Card.Body>
        </Card>
    );
}
